<template>
  <div class="container-fluid pt-4">
    <div class="row">
      <!-- left -->
      <div class="bd-sidebar col-md-3 col-xl-2 col-12"></div>
      <!-- center -->
      <div class="bd-content col-md-9 col-xl-8 col-12 pb-md-3 ">
        <b-spinner variant="info" label="Spinning" v-if="isLoading"></b-spinner>
        <h3 v-else-if="recentlyAnswered">Gracias por contestar la encuesta!</h3>
        <h3 v-else-if="isAnswered">Lo sentimos pero esta encuesta ya ha sido respondida!</h3>
        <form-wizard
          v-show="!isAnswered && !isLoading && !recentlyAnswered" 
          @on-complete="sendEntryPoll(form)" 
          @on-change="tabChanged"
          next-button-text="Siguiente"
          back-button-text="Atrás"
          finish-button-text="Enviar"
          color="#133850">
          <template slot="title">
            <h2>Hola {{firstName}} {{lastName}}!</h2>
            <p>Por favor contesta este cuestionario para preparar tus programas.</p>
          </template>
          <tab-content 
            title="Datos personales" 
            icon="ti-user"
            :before-change="() => validate('personalDataPoll')"
          >
            <PersonalDataPollComponent
              ref="personalDataPoll"
              v-model="form"
              @on-validate="onValidate"
            />
          </tab-content>
          <tab-content 
            title="Estado físico" 
            icon="ti-basketball"
            :before-change="() => validate('exercisePoll')"
          >
            <ExercisePollComponent
              ref="exercisePoll"
              v-model="form.exercise_poll"
              @on-validate="onValidate"
            />
          </tab-content>
          <tab-content 
            title="Estado nutricional" 
            icon="ti-pulse"
            :before-change="() => validate('nutritionalPoll')"
          >
            <NutritionalPollComponent
              ref="nutritionalPoll"
              v-model="form.nutritional_poll"
              @on-validate="onValidate"
            />
          </tab-content>
        </form-wizard>
      </div>
      <!-- right -->
      <div class="bd-toc col-xl-2 d-none d-xl-block">
        <div class="side-sticky">
          <ul class="section-nav nav flex-column">
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExercisePollComponent from "../components/entryPoll/ExercisePollComponent";
import NutritionalPollComponent from "../components/entryPoll/NutritionalPollComponent";
import PersonalDataPollComponent from "../components/entryPoll/PersonalDataPollComponent";
import pollsService from "../services/pollsService";
import { mapState } from "vuex";

export default {
  name: 'EntryPollUser',
  components: {
    ExercisePollComponent,
    NutritionalPollComponent,
    PersonalDataPollComponent
  },
  computed: mapState(["login"]),
  data: function() {
    return {
      isLoading: true,
      isAnswered: false,
      recentlyAnswered: false,
      firstName: "",
      lastName: "",
      form: {
        nutritional_poll: {
          digestive_symptoms: [],
          diet_type: "",
          allergies: [],
          rejected_foods: [],
          junk_food_preference: "",
          daily_consumptions: [],
          weekly_consumptions: [],
        },
        exercise_poll: {
          observation: "",
          exercise_time: null,
          exercise_type: null,
          times_week: null,
          intensity: null,
          place: null,
          tools: null,
          buy_tools: null,
          days: [],
          time_per_day: null,
          exercise_amount: []
        },
      }
    };
  },
  methods: {
    sendEntryPoll: function(form) {
      this.$toasted.success("Enviando la información...");
      this.isLoading = true;
      pollsService
        .send_entry_poll({ form: form, id: this.$route.params.id, authenticated: false })
        .then(
          data => {
            this.$toasted.success(data.message);
            this.isLoading = false;
            this.recentlyAnswered = true;
          },
          error => {
            console.log(error);
            this.$toasted.error("Ha ocurrido un error guardando la encuesta.");
            this.isLoading = false;
          }
        );
    },
    getEntryPoll: function() {
      pollsService
        .get_entry_poll({ id: this.$route.params.id, authenticated: false })
        .then(
          data => {
            this.isAnswered = data.form.is_answered;
            this.isLoading = false;
            if (!this.isAnswered) {
              this.form = data.form;
              this.$refs.nutritionalPoll.loadData(data.form.nutritional_poll);
              this.$refs.exercisePoll.loadData(data.form.exercise_poll);
              this.$refs.personalDataPoll.loadData(data.form);
              this.firstName = data.first_name;
              this.lastName = data.last_name;
            }
          },
          // eslint-disable-next-line
          error => {
            this.$toasted.error("Ha ocurrido un error cargando la encuesta.");
          }
        );
    },
    validate: function(name) {
      return this.$refs[name].validate()

    },
    onValidate: function(isValid) {
      if (!isValid) {
        this.$toasted.error("Existen errores en el cuestionario!");
      }
    },
    tabChanged: function() {
      window.scrollTo(0,0);
    },
  },
  mounted: function() {
    this.getEntryPoll();
  }
};
</script>

<style>
.bd-sidebar {
  border-right: 1px solid #eee;
}
.bd-toc {
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
</style>